export default "__VITE_ASSET__633b104e__"